import { createFileRoute } from "@tanstack/react-router"
import { ServicesDirectoryPage } from "@/components/services-directory/services-directory-page"

export const Route = createFileRoute("/_authed/_professional/professional/services")({
  component: ServicesDirectoryPage,
})
